export function PageLayout({ children }) {
  return <div className="card border-0 shadow page-layout">{children}</div>;
}
